// src/api/config.ts — Public runtime site config (checkout kill switch +
// catalog cache epoch). Read by SiteConfigContext on app load. See
// netlify/functions/get-site-config.js.

import { ApiResult } from "../types/ApiResult";

export interface SiteConfig {
  /** Server-controlled checkout kill switch. Only ever force-DISABLES. */
  checkoutEnabled: boolean;
  /** Bumped by an admin to force every visitor to drop their catalog cache. */
  catalogEpoch: number;
  /**
   * Square ITEM ids in the homepage "Classics" carousel; every other product
   * lands in "Designs". Empty = no grouping (single carousel).
   */
  classicItemIds: string[];
  /**
   * Square ITEM ids in NEITHER homepage carousel. Still on sale and in the
   * shop — just not showcased on the homepage.
   */
  homepageExcludedItemIds: string[];
  updatedAt: string | null;
}

const apiKey = process.env.REACT_APP_FUNCTION_SECRET;
const authHeaders: HeadersInit = apiKey ? { "x-api-key": apiKey } : {};

/** Fetch the public runtime site config. Fail-open shape server-side. */
export const getSiteConfig = async (): Promise<ApiResult<SiteConfig>> => {
  try {
    const response = await fetch("/.netlify/functions/get-site-config", {
      method: "GET",
      headers: { "Content-Type": "application/json", ...authHeaders },
      cache: "no-store",
    });
    return response.json();
  } catch (error) {
    return { error: `Error getting site config: ${error}` };
  }
};
